import { buildApi } from '@oncolens/oncolens-ui/lib/api/client';
import { mapDatesFromApiResponse } from '@oncolens/oncolens-ui/lib/utilities/dates';

const logoutUrl = `${window.location.protocol}//${window.location.host}/logout`;
const api = buildApi({
  logoutUrl: logoutUrl,
  doNotLogoutPaths: [
    { exact: true, path: '/' },
    { exact: false, path: '/login' },
    { exact: false, path: '/logout' },
    { exact: false, path: '/request' }
  ]
});

// For now, we're just adding an interceptor on a per-project basis, but we can do this for all clients within ui-lib in the future
api.interceptors.response.use((response) => {
  mapDatesFromApiResponse(response.data);

  return response;
});

export default api;
